const Validator = require("jsonschema").Validator;
import DateWrapper from "../common/date-wrapper";

/**
 * HACCP情報を表示データに変換する共通処理
 */
class ParserBase {
  _validator = null;
  _schema = {};
  constructor(schema) {
    this._validator = new Validator();
    this._schema = schema;
  }

  preValidateProperty(object, key, schema, options, ctx) {
    var value = object[key];
    if (typeof value === "undefined") return;

    // 検証できるよう、値の型変換を行う
    if (
      schema.type &&
      this._validator.attributes.type.call(
        this._validator,
        value,
        schema,
        options,
        ctx.makeChild(schema, key)
      )
    ) {
      // 日時文字列をISO形式（YYYY-MM-DD）に変換する
      if (schema.type == "string" && schema?.format == "date") {
        object[key] = value.replace(/\//g, "-");
        return;
      }
    }
  }

  /**
   * 受信したHACCP情報を検証する
   * @param {受信したHACCP情報} data
   * @returns 値が正しいのならTrueを返す
   */
  isCorrect(data) {
    if (!(data && data["body"])) {
      return false;
    }
    const result = this._validator.validate(data["body"], this._schema, {
      preValidateProperty: this.preValidateProperty.bind(this),
    });
    if (!result.valid) {
      console.error(data);
      console.error(result.errors);
    }
    return result.valid;
  }

  /**
   *受信したHACCP情報を表示データに変換、共通情報を追記する
   * @param {受信したHACCP情報} data
   * @returns {
   *    key: 表示順
   *    title: タイトル,
   *    message: メッセージ
   * }
   */
  toContents(data) {
    // 表示データに変換する
    let result = this.contentsParse(data["body"]);
    // 共通情報を追記する
    result.push({
      title: "最終更新日時",
      message: new DateWrapper(data["update_date"]).format.build(
        (d) =>
          `${d.date.y}年${d.date.m}月${d.date.d}日 ${d.time.h02}:${d.time.m02}`
      ),
    });
    // 表示順のインデックスをつける
    return result.map((item, index) => {
      return {
        key: index,
        title: item.title,
        message: item.message,
      };
    });
  }

  /**
   * 受信したHACCP情報を表示データに変換する
   * @param {受信したHACCP情報} data
   * @returns 表示データ
   */
  contentsParse(data) {
    console.log(data);
    return [];
  }
}

export default ParserBase;
